<template>
  <component
    :is="linkComponent"
    v-if="isDropdown && route"
    :to="resolvedRoute"
    :target="target"
    :data-qa="dataQa"
  >
    <el-dropdown-item>
      <i :class="icon" :title="title"></i>
      {{ title }}
    </el-dropdown-item>
  </component>
  <el-dropdown-item
    v-else-if="isDropdown"
    @click.native="click(row)"
    :title="title"
    :data-qa="dataQa"
  >
    <i :class="icon"></i>
    {{ title }}
  </el-dropdown-item>

  <span v-else>
    <component
      :is="linkComponent"
      v-if="resolvedRoute"
      :to="route"
      :target="target"
      :data-qa="dataQa"
    >
      <i :class="icon" :title="title"></i>
    </component>
    <i v-else :class="icon" @click="click" :title="title" :data-qa="dataQa"></i>
  </span>
</template>

<script>
export default {
  name: 'RestListAction',
  data() {
    return {
      isLinkResolved: false,
      resolvedRoute: ''
    }
  },
  computed: {
    isDropdown() {
      return this.isChildOf('ElDropdown')
    },
    linkComponent() {
      if (this.isLinkResolved) return 'router-link'

      return 'div'
    }
  },
  async mounted() {
    await this.updateRoute()
  },
  async updated() {
    await this.updateRoute()
  },
  methods: {
    isChildOf(componentName) {
      let parent = this.$parent
      while (parent) {
        if (parent.$options.name === componentName) {
          return true
        }
        parent = parent.$parent
      }
      return false
    },
    async updateRoute() {
      if (this.route) {
        await Promise.resolve(this.route).then(value => {
          this.resolvedRoute = value
          this.isLinkResolved = true
        })
      }
    }
  },
  props: {
    icon: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: false
    },

    click: {
      type: Function,
      required: false
    },
    row: {
      type: Object,
      required: false
    },
    route: {
      required: false
    },
    target: {
      type: String,
      required: false
    },
    dataQa: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
i {
  cursor: pointer;
  margin: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/rest/RestListAction.vue